<template>
  <div class="accounts">
    <template v-if="this.total > 0">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">
          {{ totalComputed }} domains related to the
          <strong>{{ query }}</strong> sender.
        </h1>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Domain</th>
            <th class="text-center">Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="domain in items" v-bind:key="domain.name">
            <td>
              <router-link
                :to="{
                  name: 'domain-details',
                  params: { domain: domain.name },
                }"
                >{{ domain.name | capitalize }}</router-link
              >
            </td>
            <td class="text-center">{{ domain.total }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <template v-if="$route.query.qs">
        <div class="alert alert-info" role="alert mt-4" v-if="!loaded">
          Loading ...
        </div>
        <div v-else class="alert alert-warning mt-4" role="alert">
          No domains found for the <strong>{{ query }}</strong> sender.
        </div>
      </template>
      <template v-else>
        <div class="alert alert-primary mt-4" role="alert">
          Use the search bar at the top to search for domains.
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { formatHttpError } from "../utils/errors";

export default {
  data() {
    return {
      loaded: false,
      total: 0,
      items: [],
    };
  },
  created() {
    this.search();
  },
  computed: {
    totalComputed() {
      if (this.total < 1000) return this.total;
      else return "1000+";
    },
    query() {
      return this.$route.query.qs;
    },
  },
  methods: {
    async search() {
      this.loaded = false;
      try {
        const response = await this.$http.post("server", {
          domain: this.$route.query.qs,
        });
        this.total = response.body.total;
        this.items = response.body.items;
      } catch (e) {
        if (e.status === 401) return;
        alert(formatHttpError(e));
      } finally {
        this.loaded = true;
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.search(true);
  },
};
</script>
